<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Persona Avatar"
    seFeDataSubtitle="A persona avatar component"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component to display a persona's avatar and basic information</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="PersonaAvatarComponent"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-table
          [seFeDataHeaders]="headers"
          [seFeDataRows]="avatarComponent">
        </se-fe-docs-table>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Persona Avatar"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-avatar-example></se-po-persona-avatar-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Persona Avatar With Title Link"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-avatar-link-example></se-po-persona-avatar-link-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Persona Avatar With Custom Subtitle"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-avatar-subtitle-example></se-po-persona-avatar-subtitle-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Persona Avatar With Subtitle Link"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-avatar-subtitle-link-example></se-po-persona-avatar-subtitle-link-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Persona Avatar With Custom Avatar and Title Sizes"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-avatar-size-example></se-po-persona-avatar-size-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Example Persona Avatar With Header Action"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-persona-avatar-action-example></se-po-persona-avatar-action-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
